/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PostRecruitmentCheckPhone200,
  PostRecruitmentCheckPhone400,
  PostRecruitmentCheckPhoneMutationRequest,
  PostRecruitmentCheckPhoneMutationResponse,
} from '../entities/PostRecruitmentCheckPhone'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1CheckPhoneRequestSchema } from './v1/checkPhoneRequestSchema'
import { v1CheckPhoneResponseSchema } from './v1/checkPhoneResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const postRecruitmentCheckPhone200Schema = z.lazy(() => v1CheckPhoneResponseSchema) as unknown as ToZod<PostRecruitmentCheckPhone200>

/**
 * @description Bad Request
 */
export const postRecruitmentCheckPhone400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostRecruitmentCheckPhone400>

/**
 * @description Параметры для проверки номера телефона
 */
export const postRecruitmentCheckPhoneMutationRequestSchema = z.lazy(
  () => v1CheckPhoneRequestSchema,
) as unknown as ToZod<PostRecruitmentCheckPhoneMutationRequest>

export const postRecruitmentCheckPhoneMutationResponseSchema = z.lazy(
  () => postRecruitmentCheckPhone200Schema,
) as unknown as ToZod<PostRecruitmentCheckPhoneMutationResponse>